exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tooltip-wrapper{position:relative;width:0;height:0}.tooltip-trigger{width:100%}.tooltip-content{position:absolute}.tooltip-content:after{content:\"\";position:absolute;border:8px solid transparent;border-top-color:inherit}.tooltip-top:after{top:100%;left:50%}.tooltip-right:after{top:50%;left:-16px;transform:rotate(90deg)}.tooltip-bottom:after{top:-16px;left:50%;transform:rotate(180deg)}.tooltip-left:after{top:50%;left:100%;transform:rotate(-90deg)}.fade-enter-active{transition:.24s ease-out}.fade-leave-active{transition:.12s ease-in}.fade-enter,.fade-leave-to{opacity:0}", ""]);

// exports
